import { render, staticRenderFns } from "./JobSeekersView.vue?vue&type=template&id=1beed0fb&scoped=true&"
import script from "./JobSeekersView.vue?vue&type=script&lang=js&"
export * from "./JobSeekersView.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekersView.vue?vue&type=style&index=0&id=1beed0fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beed0fb",
  null
  
)

export default component.exports